var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 0C4.33762 0 0 4.33918 0 9.6875C0 15.0389 4.33762 19.375 9.6875 19.375C15.0374 19.375 19.375 15.0389 19.375 9.6875C19.375 4.33918 15.0374 0 9.6875 0ZM9.6875 4.29688C10.5936 4.29688 11.3281 5.03141 11.3281 5.9375C11.3281 6.84359 10.5936 7.57812 9.6875 7.57812C8.78141 7.57812 8.04688 6.84359 8.04688 5.9375C8.04688 5.03141 8.78141 4.29688 9.6875 4.29688ZM11.875 14.2188C11.875 14.4776 11.6651 14.6875 11.4062 14.6875H7.96875C7.70988 14.6875 7.5 14.4776 7.5 14.2188V13.2812C7.5 13.0224 7.70988 12.8125 7.96875 12.8125H8.4375V10.3125H7.96875C7.70988 10.3125 7.5 10.1026 7.5 9.84375V8.90625C7.5 8.64738 7.70988 8.4375 7.96875 8.4375H10.4688C10.7276 8.4375 10.9375 8.64738 10.9375 8.90625V12.8125H11.4062C11.6651 12.8125 11.875 13.0224 11.875 13.2812V14.2188Z",
    fill: "#2A2875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/Info_Icon.d0be1841997cb4434e90a7a9524c7d21.svg";
export { ForwardRef as ReactComponent };